import {Injectable} from '@angular/core';

@Injectable({
    providedIn:'root'
})

export class Config{
  baseUrl :string = 'https://www.googleapis.com/youtube/v3/';
  apiKey : string = 'AIzaSyAOYdlWtNfmvIoYYWhlEImHjy2673xz1lI';
}